import { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';

const useCheckSubscriberAccess = (check = false, callback) => {
  const dispatch = useDispatch();
  const isNoSubscriber = useSelector( state => !state.isSubscribed );
  const storePopup = useSelector( state => state.storePopup );
  useEffect(() => {
    if (isNoSubscriber && check) {
      storePopup.b2b();
      callback();
    }
  }, [isNoSubscriber, storePopup, check, callback, dispatch])
  return null;
};

export default useCheckSubscriberAccess;
